import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PreviewItemModel } from '../../file-preview.component';
import { BasePreviewComponent } from '../base-preview/base-preview.component';
import { Config } from '@environments/config';

@UntilDestroy()
@Component({
  selector: 'text-preview',
  templateUrl: './text-preview.component.html',
  styleUrls: ['./text-preview.component.scss', '../../../file-preview-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextPreviewComponent extends BasePreviewComponent {
  @ViewChild('txtRef') txtRef: ElementRef;

  @Input() set model(model: PreviewItemModel) {
    this._model = model;
    this.loadFile();
    this.cdr.markForCheck();
  }
  get model(): PreviewItemModel {
    return this._model;
  }

  set prevWidth(val: number) {
    this._width = val;
    this.scaleEl(this.txtRef?.nativeElement, val);
  }

  get prevWidth() {
    return this._width;
  }

  private lastScale = 0;
  private DEFAULT_FONT_SIZE = 13;
  fontSize = this.DEFAULT_FONT_SIZE;
  srcUrl: string;

  private loadFile() {
    if (!this.model.item.srcUrl) return;
    this.streamContentService
      .streamTextSrc(this.model.item.srcUrl, Config.preview.files.maxSizeInMB)
      .then((url: string) => {
        this.srcUrl = url;
        if (this.txtRef?.nativeElement) {
          if (!this.model.fileType?.includes('html')) {
            this.txtRef.nativeElement.innerHTML = '';
            this.txtRef.nativeElement.innerText = this.srcUrl;
          }
        }
        this.finishLoad();
      })
      .catch((err) => {
        this.errorType = 'loadingError';
        this.finishLoad();
      });

    this.cdr.markForCheck();
  }

  scaleEl(el: HTMLElement, scale: number) {
    if (!scale) {
      this.fontSize = this.DEFAULT_FONT_SIZE;
      this.lastScale = 0;
      this.cdr.markForCheck();
      return;
    }
    if (this.lastScale <= scale) {
      this.fontSize += 2;
    }
    if (this.lastScale > scale && scale > this.DEFAULT_FONT_SIZE) {
      this.fontSize -= 2;
    }
    this.lastScale = scale;
    this.cdr.markForCheck();
  }
}
